import { graphql } from '@/gql';
import type {
  GeneratePartnerWelcomeMessageUploadPresignedUrlMutation,
  GeneratePartnerWelcomeMessageUploadPresignedUrlMutationVariables,
} from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export type GeneratePartnerWelcomeMessageUploadPresignedUrlInput = GeneratePartnerWelcomeMessageUploadPresignedUrlMutationVariables;

export type GeneratePartnerWelcomeMessageUploadPresignedUrlOutput =
  GeneratePartnerWelcomeMessageUploadPresignedUrlMutation['generatePartnerWelcomeMessageUploadPresignedUrl'];

export const generatePartnerWelcomeMessageUploadPresignedUrl = async ({
  fileName,
  partnerCodeName,
}: GeneratePartnerWelcomeMessageUploadPresignedUrlInput): Promise<GeneratePartnerWelcomeMessageUploadPresignedUrlOutput> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation GeneratePartnerWelcomeMessageUploadPresignedUrl($partnerCodeName: String!, $fileName: String!) {
        generatePartnerWelcomeMessageUploadPresignedUrl(partnerCodeName: $partnerCodeName, fileName: $fileName) {
          url
          key
          accessUrl
        }
      }
    `),
    variables: {
      partnerCodeName,
      fileName,
    },
  });

  return response.data!.generatePartnerWelcomeMessageUploadPresignedUrl;
};
